export default __webpack_public_path__ + "static/media/logo_MJ_short.3b3eb21f.png";